import AuthService from "services/auth";
import VideoCall from "pages/VideoCall";
import PublicVideoWrapper from "components/video/PublicVideoWrapper";

export default () => {
  const currentUser = AuthService.getCurrentUser();

  return currentUser ? <VideoCall /> : <PublicVideoWrapper />;
};
